// Pirate Raid — a quick DOM arcade minigame played in the Crovian System.
//
// You are ON the Dog-Pirates' side. This is THEIR raid, and you're flying it with
// them: Elite Trucking cargo drones appear on the scanner, and you tag them before
// they scramble. The spoils go to BZ-943.
//
// 🔴 The Dog-Pirates are Robin Hood figures (docs/crovian-lore.md) — they are NEVER
// the targets. An earlier version of this file had the player shooting down
// "Dog-Pirate skiffs", which inverted the comic's canon. Do not reintroduce that.
//
// Reuses the AsteroidRadar pattern (timed blips on a circular radar).

export class PirateRaid {
  constructor({ target = 10, duration = 30, onWin, onClose } = {}){
    this.target = target;
    this.duration = duration;
    this.onWin = onWin || (() => {});
    this.onClose = onClose || (() => {});
    this.hits = 0;
    this.timeLeft = duration;
    this.blips = new Set();
    this.spawnTimer = null;
    this.tickTimer = null;
    this.done = false;
  }

  mount(){
    const el = document.createElement('div');
    el.className = 'cafe-panel space-mg';
    el.innerHTML = `
      <div class="mg-card">
        <h2>🏴‍☠️ Pirate Raid</h2>
        <div class="mg-sub">Fly with the Dog-Pirates — tag <b>${this.target}</b> Elite Trucking cargo drones before they scramble!</div>
        <div class="mg-stats"><span id="mgHits">0 / ${this.target}</span><span id="mgTime">${this.duration}s</span></div>
        <div class="radar pirate-radar" id="radar">
          <div class="radar-ring"></div><div class="radar-ring r2"></div>
          <div class="radar-sweep"></div>
        </div>
        <button class="cafe-btn ghost mg-quit">retreat</button>
      </div>`;
    document.body.appendChild(el);
    this.el = el;
    this.radar = el.querySelector('#radar');
    this.hitsLabel = el.querySelector('#mgHits');
    this.timeLabel = el.querySelector('#mgTime');
    el.querySelector('.mg-quit').onclick = () => this._finish(false);

    this.spawnTimer = setInterval(() => this._spawn(), 650);
    this.tickTimer = setInterval(() => this._tick(), 1000);
    this._spawn();
  }

  _spawn(){
    if (this.done) return;
    const b = document.createElement('div');
    b.className = 'blip pirate-blip';
    b.textContent = '🐕';
    const a = Math.random() * Math.PI * 2;
    const r = Math.sqrt(Math.random()) * 42;
    b.style.left = (50 + Math.cos(a) * r) + '%';
    b.style.top = (50 + Math.sin(a) * r) + '%';
    b.onclick = () => {
      if (this.done || !this.blips.has(b)) return;
      this.hits++;
      this.hitsLabel.textContent = `${this.hits} / ${this.target}`;
      this._remove(b);
      if (this.hits >= this.target) this._finish(true);
    };
    this.radar.appendChild(b);
    this.blips.add(b);
    b._life = setTimeout(() => this._remove(b), 1100);
  }

  _remove(b){
    clearTimeout(b._life);
    this.blips.delete(b);
    b.remove();
  }

  _tick(){
    if (this.done) return;
    this.timeLeft--;
    this.timeLabel.textContent = this.timeLeft + 's';
    if (this.timeLeft <= 0) this._finish(this.hits >= this.target);
  }

  _finish(won){
    if (this.done) return;
    this.done = true;
    clearInterval(this.spawnTimer);
    clearInterval(this.tickTimer);
    this.blips.forEach(b => clearTimeout(b._life));
    this.blips.clear();
    const card = this.el.querySelector('.mg-card');
    if (won){
      card.innerHTML = `
        <h2>🦴 Convoy Scattered!</h2>
        <div class="mg-sub">Elite Trucking's drones are running. The spoils go to BZ-943 — Slice respects your aim.</div>
        <button class="cafe-btn mg-ok">claim reward</button>`;
      card.querySelector('.mg-ok').onclick = () => { this.unmount(); this.onWin(); };
    } else {
      card.innerHTML = `
        <h2>🏴‍☠️ Too Many Escaped</h2>
        <div class="mg-sub">Only ${this.hits}/${this.target} tagged. The pack got away — try again!</div>
        <button class="cafe-btn mg-ok">try again</button>
        <button class="cafe-btn ghost mg-close">leave</button>`;
      card.querySelector('.mg-ok').onclick = () => { this.unmount(); const g = new PirateRaid({ target: this.target, duration: this.duration, onWin: this.onWin, onClose: this.onClose }); g.mount(); };
      card.querySelector('.mg-close').onclick = () => { this.unmount(); this.onClose(); };
    }
  }

  unmount(){
    clearInterval(this.spawnTimer);
    clearInterval(this.tickTimer);
    this.blips.forEach(b => clearTimeout(b._life));
    this.blips.clear();
    if (this.el){ this.el.remove(); this.el = null; }
  }
}
